import { render, staticRenderFns } from "./A7CidadeFilterItem.vue?vue&type=template&id=45ffc1b4&scoped=true&"
import script from "./A7CidadeFilterItem.vue?vue&type=script&lang=js&"
export * from "./A7CidadeFilterItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ffc1b4",
  null
  
)

export default component.exports